import React, { useContext, useEffect, useRef } from 'react';
import CartContext from './Contexts/CartContext'
import AuthContext from './Contexts/AuthContext'
import axios from 'axios'
import { Redirect } from 'react-router-dom'
import { useState } from 'react';
import CartTableDetail from './CartTableDetail';
import settings from '../../settings.json'
import TitoloPagine from './TitoloPagine';
import OrderResume from './details/OrderResume';
import { SpinnerInsidePage } from '../MainComponents/Spinner';

function CartList(props) {
    const contextAuth = useContext(AuthContext)
    const contextCart = useContext(CartContext)
    const [redirectToOrders, setRedirectToOrders] = useState(false)
    const [orderId, setOrderId] = useState(undefined)
    const header = { 'headers': { 'Authorization': 'Token '+contextAuth.AuthState.token }}


    //https://www.pluralsight.com/guides/re-render-react-component-on-window-resize

    ///IMPORTANTE, RIDIMENSIONARE LE IMMAGINI

    function checkout(){
        let data={
            cart_id:contextCart.CartState.cart[0].id
        }
        axios.post(settings.url_api+"/api/orders/",data,header).then((res)=>{
            contextCart.CartDispatch({type:"ADD_NEW_ORDER",payload:res.data})
            contextCart.CartDispatch({type:"CHECKOUT_OK"})
            setOrderId(res.data["order_id"])
            setRedirectToOrders(true) 
        })
    }
    
    return (
        <>
            {contextCart.CartState.cart ?
            <>
            {contextCart.CartState.cart && contextCart.CartState.cart[0] ? 
            <>
            <div className="row">
                <div className="itemsCart col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <TitoloPagine title={"CARRELLO"}></TitoloPagine>
                    <CartTableDetail cart={contextCart.CartState.cart[0]} showButton={true} header={header}></CartTableDetail>
                </div>
                <div className="resumeCart col-lg-4 col-md-4 col-sm-12 col-xs-12" style={{textAlign:"left",margin:"0",padding:"0"}}>
                    <OrderResume checkout={checkout} subtotal={contextCart.CartState.cart[0].subtotal} tax_total={contextCart.CartState.cart[0].tax_total}></OrderResume>
                </div>
            </div>
            </>
            :
            <div style={{marginTop:"30px"}}>
                <img src="https://www.noblehealth.it/css/img/sad-cart2.png" alt=""/><br/><br/>
                <b>Il tuo carrello è vuoto</b>
            </div>}
            </>
            : 
            <SpinnerInsidePage />}

            { redirectToOrders && orderId ? <Redirect to={'/orders/'+orderId} />:null}
        </>
    );
}
export default CartList;
